import joinClassNames from '../primitives/joinClassNames.js'
import AdminTabNav from './AdminTabNav.jsx'

/**
 * Shared admin page chrome — analytics-dashboard shell with optional filled-pill tabs.
 *
 * @param {{
 *   title: React.ReactNode
 *   subtitle?: React.ReactNode
 *   headerId?: string
 *   titleId?: string
 *   headerControls?: React.ReactNode
 *   tabs?: { id: string, label: string }[]
 *   activeTab?: string
 *   onTabChange?: (id: string) => void
 *   tabAriaLabel?: string
 *   tabVariant?: 'pill' | 'link'
 *   children: React.ReactNode
 *   className?: string
 *   contentClassName?: string
 * }} props
 */
export default function AdminPageShell({
  title,
  subtitle,
  headerId,
  titleId,
  headerControls,
  tabs,
  activeTab,
  onTabChange,
  tabAriaLabel = 'Admin sections',
  tabVariant = 'pill',
  children,
  className = '',
  contentClassName = 'analytics-tab-stack',
}) {
  return (
    <div className={joinClassNames('admin-page analytics-dashboard', className)}>
      <header className="admin-page-header analytics-dashboard-header" id={headerId}>
        <div>
          <h1 id={titleId} className="page-title">{title}</h1>
          {subtitle != null && subtitle !== '' && (
            <p className="page-subtitle admin-page-subtitle-tight">{subtitle}</p>
          )}
        </div>
        {headerControls}
      </header>

      {tabs?.length > 0 && activeTab != null && onTabChange && (
        <AdminTabNav
          className="analytics-tab-nav-spaced"
          ariaLabel={tabAriaLabel}
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={onTabChange}
          variant={tabVariant}
        />
      )}

      <div className={contentClassName}>{children}</div>
    </div>
  )
}
